import React from "react";

import Edit from "./Edit";
import Create from "./Create";

const Entry = ({ props, match }) => {
  return <Edit />;
};

export default Entry;



// WEBPACK FOOTER //
// ./src/containers/Pages/index.jsx